export default import.meta.ROLLUP_FILE_URL_i2ywl_YzKp2MjtOEr7ngzA;